import React, { useEffect } from 'react';
import {Tooltip as TooltipRecharts} from 'recharts';
import {
  IconButton,
  Grid, 
  Paper,
  Tooltip
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import {
  ScatterChart, Scatter, XAxis, YAxis, CartesianGrid,LabelList, ResponsiveContainer,Label
} from 'recharts';


import socket from '../../../../services/socket';
import Title from '../../../../components/Title';
import useStylesMain from '../../../../useStyles';

export default function ConvertionAttendanceScatter(props) {
    const classesMain = useStylesMain()
    const [data,setData] = React.useState([])
    const [selectedData,setSelectedData] = React.useState([])

    useEffect( () => {   
      function askConvAttenScatter(props){
        let ids = []
        props.storesDisplayed.forEach((stores)=>{
          ids.push(stores.store_id)
        })
        socket.emit('/vezo/histData/askConvAttenScatter',{ 
                                            'store_id_list': ids,
                                            'date': props.date,
                                            }
                                        ,(data)=>{console.log(data);});
      }

      async function loadConvAttenScatter(props){
          askConvAttenScatter(props);
          socket.on('/vezo/histData/askConvAttenScatter',()=>{
            // When the server sends a updatePaperInfo, it asks for newer intel
            askConvAttenScatter(props);
          })  
          socket.on('/vezo/histData/ConvAttenScatter',(data)=>{
            setData(data)
          })
          return () => socket.disconnect();
      }
      loadConvAttenScatter(props);       
    },[props]);  

    useEffect(()=>{
      let ids = []
      props.storesDisplayed.forEach((stores)=>{
        ids.push(stores.store_id)
      })
      
      const result = data.filter(store => ids.includes(store.id) )
      setSelectedData(result)

    },[data,props])

    return (
        <Grid item xs={12} md={12} lg={6}>
            <Paper className={classesMain.paper}>
                <Grid container spacing={3}  direction="row">
                    <Grid item  justifyContent='flex-start'>
                        <Tooltip title="Gráfico relacionando atendimentos e conversão de cada loja!">
                        <IconButton aria-label="Selecionar" size="large">
                            <InfoIcon />
                        </IconButton>
                        </Tooltip>
                    </Grid>
                    <Grid item xs justifyContent={"flex-start"}> 
                        <Title>Performance</Title>
                    </Grid>
                </Grid>
                <ResponsiveContainer width='100%' height={400}>
                    <ScatterChart
                    width={500}
                    height={400}
                    margin={{
                        top: 20, right: 20, bottom: 20, left: 20,
                    }}
                    >
                        <CartesianGrid />
                        <XAxis type="number" dataKey="attendance" label = {
                            <Label
                            angle={0}
                            position="bottom"
                            value="Atendimentos"
                            />
                        }
                        name="Atendimentos" domain={[0,'dataMax + 30']}/>
                        <YAxis type="number" dataKey="conversion" label = {
                        <Label
                            angle={270}
                            position="left"
                            value="Conversão"
                            />} 
                            name="Conversão" unit="%" domain={[0, dataMax => ((dataMax+30>=100)?120:dataMax+30)]}/>
                        <TooltipRecharts cursor={{ strokeDasharray: '3 3' }} />
                        <Scatter name="" data={selectedData} fill="#8884d8">
                            <LabelList dataKey="name" offset="10" position="top"/>
                        </Scatter>
                    </ScatterChart>
                </ResponsiveContainer>
            </Paper>
        </Grid>
    );
}